'use client'

import { StreamableValue, useStreamableValue } from 'ai/rsc'
import { MemoizedReactMarkdown } from './ui/markdown'
import rehypeExternalLinks from 'rehype-external-links'
import remarkGfm from 'remark-gfm'
import { CustomImageRenderer } from './custom-image'

export function BotMessage({ content }: { content: StreamableValue<string> }) {
  const [data, error, pending] = useStreamableValue(content)

  // Currently, sometimes error occurs after finishing the stream.
  if (error) return <div>Error</div>
  if (!data) return null

  const preprocessContent = (content: string) => {
    const partialImageMarkdownRegex = /!\[([^\]]*)\]\((https?:\/\/[^\)]*)?$/g

    // Replace partial Markdown image links with a placeholder while streaming
    return content.replace(
      partialImageMarkdownRegex,
      (_, alt) => `![${alt}](placeholder)`
    )
  }

  return (
    <MemoizedReactMarkdown
      rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }, remarkGfm]]}
      className="prose-sm prose-neutral prose-a:text-accent-foreground/50"
      components={{
        img: ({ node, ...props }) => <CustomImageRenderer {...props} />
      }}
    >
      {preprocessContent(data)}
    </MemoizedReactMarkdown>
  )
}
